module.exports = __webpack_public_path__ + "media/components/assets/icons/kakao_symbol_logo-65f835c759bf89bea69d04fc756b95ca.png";